const getProductData = () => window.productData
const getRoot = () => window.productFormRoot || document
let selectedColor = null
let selectedSize = null
let currentVariantImages = []
let productSwiper = null
let quickAddSwiper = null

window.changeMainImage = function (imageUrl, button) {
  document.getElementById('main-product-image').src = imageUrl

  // Update border styling
  document.querySelectorAll('[onclick*="changeMainImage"]').forEach((btn) => {
    btn.classList.remove('border-primary')
    btn.classList.add('border-gray-200')
  })
  button.classList.remove('border-gray-200')
  button.classList.add('border-primary')
}

window.selectColor = function (button, color) {
  selectedColor = color

  getRoot()
    .querySelectorAll('[data-color]')
    .forEach((btn) => {
      btn.classList.remove('border-primary')
      btn.classList.add('border-gray-300')
    })
  button.classList.remove('border-gray-300')
  button.classList.add('border-primary')

  // Update displayed color name
  const colorDisplay = getRoot().querySelector('#selected-color')
  if (colorDisplay) colorDisplay.textContent = color

  // Update available sizes for this color
  updateSizesAvailability(color)

  // Update images for this color variant
  updateImagesForColor(color)

  updateVariant()
  checkAddToCartButton()
}

function updateSizesAvailability(selectedColor) {
  const sizeButtons = getRoot().querySelectorAll('[data-size]')

  sizeButtons.forEach((sizeBtn) => {
    const size = sizeBtn.dataset.size

    // Find if there's an available variant for this color + size combination
    const isAvailable = getProductData().variants.some((v) => {
      const matchesColor = v.option1 === selectedColor || v.option2 === selectedColor
      const matchesSize = v.option1 === size || v.option2 === size
      return matchesColor && matchesSize && v.available
    })

    // Update button state
    sizeBtn.dataset.available = isAvailable
    sizeBtn.disabled = !isAvailable
    const strike = sizeBtn.querySelector('[data-size-strike]')

    // Update styling
    if (isAvailable) {
      sizeBtn.classList.remove(
        'border-[#CCCCCC]',
        'bg-[#F5F5F580]',
        'text-[#CCCCCC]',
        'cursor-not-allowed',
        'border-primary'
      )
      sizeBtn.classList.add(
        'border-transparent',
        'bg-[#F5F5F5]',
        'text-black',
        'hover:border-primary',
        'cursor-pointer'
      )
      if (strike) strike.classList.add('hidden')
    } else {
      sizeBtn.classList.remove(
        'border-transparent',
        'bg-[#F5F5F5]',
        'text-black',
        'hover:border-primary',
        'border-primary',
        'cursor-pointer'
      )
      sizeBtn.classList.add('border-[#CCCCCC]', 'bg-[#F5F5F580]', 'text-[#CCCCCC]', 'cursor-not-allowed')
      if (strike) strike.classList.remove('hidden')
    }
  })

  // Reset selected size when changing color and auto-select first available size
  selectedSize = null
  const firstAvailableSize = document.querySelector('[data-size]:not([disabled])')
  if (firstAvailableSize) {
    window.selectSize(firstAvailableSize, firstAvailableSize.dataset.size)
  }
}

// Build color -> image ID map using Liquid-provided imageColorData
// Liquid reliably detects which images are featured images for which color variant
// JS then fills in unassigned images using forward propagation
function buildColorImageMap() {
  const data = window.imageColorData
  if (!data || data.length === 0) return null

  // Log raw data from Liquid for debugging
  console.log(
    'Raw image color data from Liquid:',
    data.map((d) => d.id + '=' + (d.color || '?'))
  )

  // Forward propagation: unassigned images inherit color from previous boundary
  let lastColor = null
  for (const item of data) {
    if (item.color) {
      lastColor = item.color
    } else {
      item.color = lastColor
    }
  }

  // Build map
  const map = {}
  for (const item of data) {
    if (!item.color) continue
    if (!map[item.color]) map[item.color] = []
    map[item.color].push(item.id)
  }

  console.log('Color image map:', Object.fromEntries(Object.entries(map).map(([k, v]) => [k, v.length + ' images'])))
  return map
}

let colorImageMap = null

function updateImagesForColor(selectedColor) {
  if (!selectedColor) return

  // Build map on first use
  if (!colorImageMap) {
    colorImageMap = buildColorImageMap()
  }

  const colorImageIds = colorImageMap ? colorImageMap[selectedColor] : null

  // Update desktop gallery
  const desktopImages = getRoot().querySelectorAll('#desktop-gallery .product-image')
  desktopImages.forEach((imageDiv) => {
    if (colorImageIds) {
      imageDiv.style.display = colorImageIds.includes(imageDiv.dataset.imageId) ? 'block' : 'none'
    } else {
      imageDiv.style.display = 'block'
    }
  })

  // Update mobile swiper
  const mobileSlides = getRoot().querySelectorAll('#mobile-swiper .product-image')
  mobileSlides.forEach((slide) => {
    if (colorImageIds) {
      slide.style.display = colorImageIds.includes(slide.dataset.imageId) ? 'block' : 'none'
    } else {
      slide.style.display = 'block'
    }
  })

  applyGalleryLimit()

  const swiper = getRoot().id === 'product-quick-add-root' ? quickAddSwiper : productSwiper
  if (swiper) {
    swiper.update()
    swiper.slideTo(0)
  }
}

// Desktop only: cap visible images and turn the (limit+1)th tile into a "show all photos" tile.
// Tiles beyond stay in the DOM (display:none) so Fancybox can still cycle through them.
function applyGalleryLimit() {
  const gallery = getRoot().querySelector('#desktop-gallery')
  if (!gallery) return
  const limit = parseInt(gallery.dataset.galleryLimit, 10) || 5
  const tiles = Array.from(gallery.querySelectorAll('.product-image'))

  // Reset any prior "show more" state and limit-hidden state.
  tiles.forEach((t) => {
    if (t.dataset.showMore === 'true') {
      t.dataset.showMore = ''
      t.classList.remove('product-image--more', 'relative', 'cursor-pointer', 'group')
      const img = t.querySelector('img')
      if (img)
        img.classList.remove(
          'scale-105',
          'blur-[6px]',
          'transition-transform',
          'duration-500',
          'ease-out',
          'group-hover:scale-110'
        )
      const overlay = t.querySelector('.show-more-overlay')
      if (overlay) overlay.remove()
    }
    if (t.dataset.limitHidden === 'true') {
      t.dataset.limitHidden = ''
      // Only un-hide if color filter didn't hide it
      // (updateImagesForColor sets display before us — trust that.)
    }
  })

  // Walk color-visible tiles in order; apply limit.
  let visibleIndex = 0
  tiles.forEach((tile) => {
    if (tile.style.display === 'none') return
    visibleIndex += 1
    if (visibleIndex === limit + 1) {
      transformToShowMore(tile)
    } else if (visibleIndex > limit + 1) {
      tile.dataset.limitHidden = 'true'
      tile.style.display = 'none'
    }
  })
}

function transformToShowMore(tile) {
  tile.dataset.showMore = 'true'
  tile.classList.add('product-image--more', 'relative', 'cursor-pointer', 'group')
  const img = tile.querySelector('img')
  if (img)
    img.classList.add(
      'scale-105',
      'blur-[6px]',
      'transition-transform',
      'duration-500',
      'ease-out',
      'group-hover:scale-110'
    )

  const label = (window.productTranslations && window.productTranslations.showAllPhotos) || 'Show all photos'
  const overlay = document.createElement('div')
  overlay.className =
    'show-more-overlay absolute inset-0 z-10 flex flex-col items-center justify-center bg-primary/40 pointer-events-none transition-colors duration-300 ease-out group-hover:bg-primary/60'
  overlay.innerHTML = `
    <div class="flex flex-col items-center gap-2 transition-transform duration-300 ease-out group-hover:scale-110">
      <svg class="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5"/>
        <rect x="14" y="3" width="7" height="7" rx="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1.5"/>
        <rect x="14" y="14" width="7" height="7" rx="1.5"/>
      </svg>
      <span class="text-white text-[16px] tracking-[0.03em]">${label}</span>
    </div>
  `
  tile.appendChild(overlay)
}

window.selectSize = function (button, size) {
  if (button.disabled) return

  selectedSize = size

  // Update border styling - remove border-primary from all, add to selected
  getRoot()
    .querySelectorAll('[data-size]')
    .forEach((btn) => {
      if (!btn.disabled) {
        btn.classList.remove('border-primary')
        btn.classList.add('border-transparent')
      }
    })
  button.classList.remove('border-transparent')
  button.classList.add('border-primary')

  updateVariant()
  checkAddToCartButton()
}

function updateVariant() {
  // Fallback for products with no color/size options on the page —
  // use the first available variant so price + ATC still resolve.
  if (!selectedSize && !selectedColor) {
    const hasColorBtns = !!getRoot().querySelector('[data-color]')
    const hasSizeBtns = !!getRoot().querySelector('[data-size]')
    if (hasColorBtns || hasSizeBtns) return

    const variants = getProductData().variants || []
    const variant = variants.find((v) => v.available) || variants[0]
    if (!variant) return

    const input = getRoot().querySelector('input[name="id"]')
    if (input) input.value = variant.id
    updatePrice(variant)
    updateStockStatus(variant)
    return
  }

  // Find matching variant
  const variant = getSelectedVariant()

  if (variant) {
    // Update hidden input
    const input = getRoot().querySelector('input[name="id"]')
    if (input) input.value = variant.id

    // Update price
    updatePrice(variant)

    // Update stock status
    updateStockStatus(variant)

    // Update button state
    const addToCartBtn = getRoot().querySelector('#add-to-cart-btn')
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available
      addToCartBtn.textContent = window.productTranslations.addToCart
    }
  }
}

function getSelectedVariant() {
  return getProductData().variants.find((v) => {
    const matchesColor = !selectedColor || v.option1 === selectedColor || v.option2 === selectedColor
    const matchesSize = !selectedSize || v.option1 === selectedSize || v.option2 === selectedSize
    return matchesColor && matchesSize
  })
}

function updatePrice(variant) {
  const priceContainer = getRoot().querySelector('#product-price')
  if (!priceContainer) return

  const price = formatMoney(variant.price)
  const comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null

  if (comparePrice && variant.compare_at_price > variant.price) {
    const savingPct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
    // Rule of 100: absolute savings only on high-ticket items (€100+ equivalent)
    const highTicketCents = window.shopCurrency?.code === 'CZK' ? 250000 : 10000
    let saveHtml = ''
    if (variant.compare_at_price >= highTicketCents) {
      const saving = formatMoney(variant.compare_at_price - variant.price)
      const label = (window.productTranslations?.youSave || 'You save {{ amount }}').replace('{{ amount }}', saving)
      saveHtml = `<span class="text-[13px] leading-none font-medium text-accent-red">${label}</span>`
    }
    priceContainer.innerHTML = `
      <div class="flex items-center flex-wrap gap-x-3 gap-y-1">
        <span class="text-[28px] leading-none lg:text-[36px] tracking-[0.02em] font-medium text-primary">${price}</span>
        <span class="text-[16px] lg:text-[18px] text-primary/40 line-through">${comparePrice}</span>
        <span class="text-[13px] leading-none font-medium text-accent-red bg-accent-red/10 rounded-full px-2.5 py-1">-${savingPct}%</span>
        ${saveHtml}
      </div>
    `
  } else {
    priceContainer.innerHTML = `<span class="text-[28px] leading-none lg:text-[36px] tracking-[0.02em] font-medium text-primary">${price}</span>`
  }

  updateOmnibusLowestPrice(variant)

  // Keep the mobile sticky bar + variant drawer prices in sync with the same variant
  const onSale = comparePrice && variant.compare_at_price > variant.price
  ;[
    { el: getRoot().querySelector('#sticky-price'), main: 'text-[15px]', cmp: 'text-[12px]' },
    { el: getRoot().querySelector('#drawer-price'), main: 'text-[16px]', cmp: 'text-[13px]' },
  ].forEach(({ el, main, cmp }) => {
    if (!el) return
    el.innerHTML = onSale
      ? `<span class="${main} font-medium text-primary">${price}</span>` +
        `<span class="${cmp} text-primary/40 line-through">${comparePrice}</span>`
      : `<span class="${main} font-medium text-primary">${price}</span>`
  })

  // Sale deadline line only applies to variants that are actually discounted
  const urgency = getRoot().querySelector('#product-sale-urgency')
  if (urgency) urgency.style.display = onSale ? '' : 'none'

  // Reveal price after JS formatting (prevents flash of Liquid format)
  priceContainer.style.visibility = 'visible'
}

function updateOmnibusLowestPrice(variant) {
  const priceContainer = getRoot().querySelector('#product-price')
  if (!priceContainer) return

  let line = getRoot().querySelector('[data-omnibus-lowest-price]')
  const onSale = variant.compare_at_price != null && variant.compare_at_price > variant.price
  const cents = window.variantOmnibusPrices?.[String(variant.id)]
  const hasOmnibus = onSale && cents != null && Number(cents) > 0

  if (!hasOmnibus) {
    if (line) line.remove()
    return
  }

  const formatted = formatMoney(Number(cents))
  const template =
    window.productTranslations?.omnibusLowestPrice30Days || 'Niedrigster Preis der letzten 30 Tage: {{ price }}'
  const text = template.replace('{{ price }}', formatted)

  if (!line) {
    line = document.createElement('p')
    line.setAttribute('data-omnibus-lowest-price', '')
    line.className = 'mt-2 text-[12px] lg:text-[13px] leading-snug text-primary/60'
    priceContainer.insertAdjacentElement('afterend', line)
  }
  line.textContent = text
}

function updateStockStatus(variant) {
  const stockInfo = getRoot().querySelector('#stock-info')
  if (!stockInfo) return

  if (variant.available) {
    stockInfo.innerHTML = `
      <div class="w-2 h-2 flex items-center justify-center rounded-full bg-[#A5CB0466]">
      <div class="w-1 h-1 rounded-full bg-[#A5CB04]"></div>
      </div>
      <p class="text-[14px] text-primary leading-4.5">${window.productTranslations.inStock}</p>
    `
  } else {
    stockInfo.innerHTML = `
      <div class="w-2 h-2 rounded-full bg-red-400"></div>
      <p class="text-[14px] text-red-600">${window.productTranslations.outOfStock}</p>
    `
  }
}

function formatMoney(price) {
  // Shopify price is in cents
  const priceInMajorUnits = typeof price === 'string' ? parseFloat(price) / 100 : price / 100

  // Get currency from Shopify settings
  const currency = window.shopCurrency?.code || 'EUR'

  // Determine locale based on currency
  const locale = currency === 'CZK' ? 'cs-CZ' : currency === 'EUR' ? 'de-DE' : 'en-US'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInMajorUnits)
}

function checkAddToCartButton() {
  const addToCartBtn = getRoot().querySelector('#add-to-cart-btn')
  if (!addToCartBtn) return

  addToCartBtn.textContent = window.productTranslations.addToCart

  // Only require an option to be selected if its selector is on the page.
  // Products with no color/size selectors (single variant) should still enable.
  const needsColor = !!getRoot().querySelector('[data-color]')
  const needsSize = !!getRoot().querySelector('[data-size]')

  if ((!needsColor || selectedColor) && (!needsSize || selectedSize)) {
    let variant
    if (needsColor || needsSize) {
      variant = getSelectedVariant()
    } else {
      const variants = getProductData().variants || []
      variant = variants.find((v) => v.available) || variants[0]
    }
    addToCartBtn.disabled = !variant || !variant.available
  } else {
    addToCartBtn.disabled = true
  }
}

function initProductForm(rootEl) {
  const root = rootEl || document
  if (quickAddSwiper) {
    quickAddSwiper.destroy(true, true)
    quickAddSwiper = null
  }
  const swiperEl = root.querySelector('.product-images-swiper')
  if (swiperEl) {
    const isQuickAdd = root.id === 'product-quick-add-root'
    const swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: false,
      pagination: {
        el: swiperEl.querySelector('.product-images-swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 3,
      },
    })
    if (isQuickAdd) quickAddSwiper = swiperInstance
    else productSwiper = swiperInstance
  }

  selectedColor = null
  selectedSize = null
  colorImageMap = null

  const savedVariantId = localStorage.getItem(`selectedVariant_${getProductData().id}`)
  let selectedVariant = null
  if (savedVariantId && getProductData().variants) {
    selectedVariant = getProductData().variants.find((v) => v.id == savedVariantId)
    localStorage.removeItem(`selectedVariant_${getProductData().id}`)
  }

  const firstColorBtn = root.querySelector('[data-color]')
  if (selectedVariant && firstColorBtn) {
    const variantColor = selectedVariant.option1 || selectedVariant.option2 || selectedVariant.option3
    const colorBtn = root.querySelector(`[data-color="${variantColor}"]`)
    if (colorBtn) window.selectColor(colorBtn, variantColor)
    else window.selectColor(firstColorBtn, firstColorBtn.dataset.color)
  } else if (firstColorBtn) {
    window.selectColor(firstColorBtn, firstColorBtn.dataset.color)
  } else {
    const firstSizeBtn = root.querySelector('[data-size]:not([disabled])')
    if (firstSizeBtn) window.selectSize(firstSizeBtn, firstSizeBtn.dataset.size)
  }
  updateVariant()
  checkAddToCartButton()
}

function bindFancyboxGallery(container, selector, options) {
  const Fancybox = window.Fancybox
  if (!Fancybox || !container) return

  Fancybox.unbind(container, selector)
  Fancybox.bind(container, selector, options)
}

function initProductFancyboxBindings() {
  const Fancybox = window.Fancybox
  if (!Fancybox) return

  const options = { Hash: false }
  const selector = '[data-fancybox^="product-pdp-"]'

  const main = document.getElementById('MainContent')
  if (main) {
    // Desktop + mobile galleries share the same data-fancybox group name but render
    // duplicate <a> tags — bind each container separately so lightbox slides aren't doubled.
    bindFancyboxGallery(main.querySelector('#desktop-gallery'), selector, options)
    bindFancyboxGallery(main.querySelector('#mobile-swiper'), selector, options)
  }

  const qaModal = document.querySelector('[data-product-quick-add-modal]')
  if (qaModal) {
    const qaSelector = '[data-fancybox^="product-qa-"]'
    bindFancyboxGallery(qaModal.querySelector('#desktop-gallery'), qaSelector, options)
    bindFancyboxGallery(qaModal.querySelector('#mobile-swiper'), qaSelector, options)
  }
}

/** Feeds the header search panel's "recently viewed" section. */
function recordProductViewForSearch() {
  const product = window.productData
  if (!product || !window.HuskySearch) return

  const image = product.featured_image || product.images?.[0] || ''

  window.HuskySearch.recordProductView({
    title: product.title,
    url: product.url || `/products/${product.handle}`,
    image: typeof image === 'string' ? image : image.src || '',
    price: product.price,
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initProductFancyboxBindings()
  if (!window.productData) return
  recordProductViewForSearch()
  window.productFormRoot = null
  initProductForm(document)
})

document.addEventListener('product-quick-add:ready', () => {
  const root = document.getElementById('product-quick-add-root')
  if (!root || !window.productData) return
  window.productFormRoot = root
  initProductForm(root)
  initProductFancyboxBindings()
})
